module.exports = __webpack_public_path__ + "media/Images/question-8e8e971d0b03116d7eba11c924480e23.svg";